import { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { LEGAL_CONTACT_EMAIL } from '@/features/legal/lib/legalDocuments'
import { cn } from '@/lib/utils'
import { ROUTES } from '@/navigation/constants'

import { Checkbox } from './ui/checkbox'

type PhoneCommercialConsentBlockProps = {
    consentChecked: boolean
    onCheckedChange: (checked: boolean) => void
    consentInputId?: string
    labelClassName?: string
}

const emailLinkClassName = 'font-medium text-primary underline-offset-2 hover:underline'

function DeferredContactEmailLink() {
    const [email, setEmail] = useState<string | null>(null)

    useEffect(() => {
        setEmail(LEGAL_CONTACT_EMAIL)
    }, [])

    if (!email) {
        return <span className={emailLinkClassName} aria-hidden />
    }

    return (
        <a href={`mailto:${email}`} className={emailLinkClassName}>
            {email}
        </a>
    )
}

export function LeadFormConsentLegalNotice({ className }: { className?: string }) {
    return (
        <p className={cn('text-xs leading-relaxed', className ?? 'text-muted-foreground')}>
            <Trans
                i18nKey='leadForm.consentSubtext'
                components={{
                    privacyLink: (
                        <a
                            href={ROUTES.privacyPolicy}
                            className='font-medium text-primary underline-offset-2 hover:underline'
                        />
                    ),
                    emailLink: <DeferredContactEmailLink />,
                }}
            />
        </p>
    )
}

export function PhoneCommercialConsentBlock({
    consentChecked,
    onCheckedChange,
    consentInputId = 'consent',
    labelClassName,
}: PhoneCommercialConsentBlockProps) {
    const { t } = useTranslation()

    return (
        <div className='flex items-start gap-2'>
            <Checkbox
                id={consentInputId}
                checked={consentChecked}
                onCheckedChange={onCheckedChange}
                className='mt-0.5'
            />
            <label
                htmlFor={consentInputId}
                className={cn(
                    'text-sm leading-snug peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
                    labelClassName,
                )}
            >
                {t('leadForm.consentText')}
            </label>
        </div>
    )
}
